import { apiFetch } from "../../api";
import {BASE_URL as u} from "../../../commonUrls";

const BASE = `${u}/investment`;

export async function createInvestment(payload){
  return apiFetch(BASE,{
    method:"POST",
    body: JSON.stringify(payload)
  });
}

export async function getInvestments(){
  const res = await apiFetch(`${BASE}/user`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function closeInvestment(id){
  return apiFetch(`${BASE}/${id}/close`,{
    method:"PUT"
  });
}
